import { render, staticRenderFns } from "./contentConsent.vue?vue&type=template&id=79ab7e9a&scoped=true&"
import script from "./contentConsent.vue?vue&type=script&lang=ts&"
export * from "./contentConsent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ab7e9a",
  null
  
)

export default component.exports